import { render, staticRenderFns } from "./LeagueStanding.vue?vue&type=template&id=1e0f07ac&scoped=true&"
import script from "./LeagueStanding.vue?vue&type=script&lang=js&"
export * from "./LeagueStanding.vue?vue&type=script&lang=js&"
import style0 from "./LeagueStanding.vue?vue&type=style&index=0&id=1e0f07ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0f07ac",
  null
  
)

export default component.exports